import { BreadcrumbSection } from "@hermes/aphrodite/breadcrumb";
import { ProductBreadcrumb } from "@hermes/api-model-product";

export function computeBreadcrumbSectionsForProductPage(
    productBreadcrumbs: ProductBreadcrumb[] | undefined,
    isLvl1Clickable: boolean,
): BreadcrumbSection[] {
    return productBreadcrumbs
        ? productBreadcrumbs.map((productBreadcrumb, index) => ({
              ...productBreadcrumb,
              unclickable: index === 0 && !isLvl1Clickable,
          }))
        : [];
}
